import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const selectRecipeFn = /* @__PURE__ */ createRecipe('selectRecipe', {
  "variant": "fit"
}, [])

const selectRecipeVariantMap = {
  "variant": [
    "fit",
    "full"
  ]
}

const selectRecipeVariantKeys = Object.keys(selectRecipeVariantMap)

export const selectRecipe = /* @__PURE__ */ Object.assign(memo(selectRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'selectRecipe',
  __getCompoundVariantCss__: selectRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: selectRecipeVariantKeys,
  variantMap: selectRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, selectRecipeVariantKeys)
  },
  getVariantProps: selectRecipeFn.getVariantProps,
})